<template>
  <v-card
    id="dashboard-card-empresa"
    class="mx-auto"
    outlined
    elevation="1"
  >
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          sm="4"
        >
          <v-list-item>
            <v-list-item-content class="text--secondary">
              <b>Empresa: </b>{{ empresa.nome }}
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-content class="text--secondary">
              <b>Municipio: </b>{{ empresa.cidade }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="text--secondary">
              <b>Telefone: </b>{{ empresa.telefone }}
            </v-list-item-content>
          </v-list-item> -->
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-list-item>
            <v-list-item-content class="text--secondary">
              <b>Razão Social: </b>{{ empresa.razaosocial }}
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-content class="text--secondary">
              <b>Inscrição Estadual: </b>{{ empresa.inscricaoestadual }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="text--secondary">
              <b>CEP: </b>{{ empresa.cidade }}
            </v-list-item-content>
          </v-list-item> -->
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-list-item>
            <v-list-item-content class="text--secondary">
              <b>CNPJ: </b> {{ empresa.cnpj }}
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'CardEmpresa',

    props: {
      empresa: {
        type: Object,
        default: function () {
          return {
            nome: 'Nome da Empresa',
            endereco: 'Endereço da empresa',
            cidade: 'Cidade',
            telefone: '(31) 999565875',
            cnpj: '04.439.268/0001-85',
            inscricaoestadual: '27.103.329-0',
          }
        },
      },
    },

    data: () => ({

    }),

    mounted () {
      // console.log(this.empresa)
    },
  }
</script>
